import styled from 'styled-components'
import { taskTypeMeta } from 'features/taskManagement/taskType'

const TaskTypeBadge = ({ task, className }) => {
  const meta = taskTypeMeta(task)
  return (
    <Badge className={className} $color={meta.color} $bg={meta.bg} title={meta.title}>
      {meta.label}
    </Badge>
  )
}

export default TaskTypeBadge

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1.4;
  padding: 1px 7px;
  border-radius: 10px;
  color: ${({ $color }) => $color};
  background: ${({ $bg }) => $bg};
  white-space: nowrap;
`
